import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

import { gpaGuideContent } from '../content';

const mythsDetail = [
  gpaGuideContent.mythsVsReality.intro,
  ...gpaGuideContent.mythsVsReality.myths.map((myth) => `Myth: ${myth.title} — ${myth.body}`),
].join('\n');

export const useAgentContext = () => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Overview',
    description:
      'Introductory section explaining what GPA is and why it matters for college admissions, scholarships, and career readiness. Includes discussion question prompts.',
    detail: [
      gpaGuideContent.header.description.join('\n'),
      'Discussion questions:',
      ...gpaGuideContent.discussionQuestions.questions,
    ].join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: gpaGuideContent.broaderValue.title,
    description:
      'Explains the broader value of a strong GPA beyond admissions, including eligibility, preparation, confidence, habits, and opportunities.',
    detail: [
      gpaGuideContent.broaderValue.intro,
      ...gpaGuideContent.broaderValue.items.map((item) => `${item.label}: ${item.description}`),
      gpaGuideContent.broaderValue.conclusion,
    ].join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: gpaGuideContent.tools.title,
    description: 'Backrs tools and curated study resources to support academic success.',
  });

  useRegisterAgentContext({
    kind: 'section',
    title: gpaGuideContent.corePrinciples.title,
    description:
      'Five core principles for building and sustaining a strong GPA, plus how to tell your academic story.',
    detail: [
      ...gpaGuideContent.corePrinciples.principles.map((p) => `${p.number}. ${p.title}: ${p.body}`),
      `Telling Your Academic Story: ${gpaGuideContent.tellingYourStory.intro}`,
      ...gpaGuideContent.tellingYourStory.questions,
    ].join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: gpaGuideContent.fourYearFramework.title,
    description: 'A year-by-year framework for GPA management from 9th through 12th grade.',
    detail: gpaGuideContent.fourYearFramework.years
      .map((y) => `${y.title}: ${y.points.join('; ')}`)
      .join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: gpaGuideContent.mythsVsReality.title,
    description:
      'Common misconceptions about GPA paired with reality checks, covering weighted vs unweighted GPA, course rigor, year importance, and more.',
    detail: mythsDetail,
  });

  useRegisterAgentContext({
    kind: 'section',
    title: gpaGuideContent.strategyByGoal.title,
    description:
      'Tailored GPA strategies for different student paths: college-bound, highly selective, CTE, and scholarship applicants.',
    detail: gpaGuideContent.strategyByGoal.strategies
      .map((s) => `${s.title}: ${s.points.join('; ')}`)
      .join('\n'),
  });
};
